<template>
  <div class="archive-modify-view">
    <div class="tip-info">
      <div style="margin-bottom: 1rem;">
        <van-icon style="margin: .5rem .5rem 0 0;" name="info" />
        <span>重要提醒</span>
      </div>
      <p><span>*</span> 请按照个人真实信息进行如实填写不得恶意篡改个人信息</p>
      <p>
        <span>*</span>
        修改信息之前请确认所选择的就诊卡是否为您真实需要修改的就诊卡
      </p>
      <p>
        <span>*</span>
        请注意，修改信息后不代表本就诊卡修改前的账号行为和相关责任得到豁免或减轻
      </p>
    </div>

    <div
      style="margin-top: 1rem;padding-left: .5rem;font-weight: 500;line-height: 3rem;background: white"
    >
      院内个人基本信息
    </div>

    <van-form @submit="onSubmit">
      <van-field :value="cardNo" label="卡号" disabled />
      <van-field v-model="name" label="姓名" />
      <van-field
        v-model="idCard"
        :rules="[{ required: true, message: '请填写正确的身份证号' }]"
        label="身份证"
        placeholder="请输入身份证号"
      />
      <van-field
        v-model="telphone"
        :rules="[{ required: true, message: '请填写正确的手机号' }]"
        label="手机号"
        placeholder="请输入手机号"
      />
      <!-- <van-field
        v-model="phoneCode"
        placeholder="短信验证码"
        :rules="[{ required: true, message: '请填写短信验证码' }]"
      >
        <ph-button
          slot="right-icon"
          :disabled="countDownTime > 0"
          :type="countDownTime ? 'default' : 'info'"
          @click="sendCode"
        >
          {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
        </ph-button>
      </van-field> -->
      <div style="margin: .5rem;">
        <div style="color: red;font-size: .75rem;">
          当您点击立即修改按钮，即表示您已阅读并同意以上内容
        </div>
        <ph-button
          title="立即修改"
          style="width:100%;margin:.5rem 0"
          native-type="submit"
        />
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardNo: "",
      name: "",
      idCard: "",
      telphone: "",
      verifyCode: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null,
      patientId: ""
    };
  },
  created() {
    // this.getVerifyCode();
    this.getBaseInfo();
  },
  methods: {
    bind() {},
    getBaseInfo() {
      this.$http
        .post(this.$api.USER_BASE_INFO_QRCODE, {
          functionType: "1"
        })
        .then(res => {
          this.cardNo = res.cardNo;
          this.name = res.patientName;
          this.idCard = res.idCard;
          this.telphone = res.phone;
          this.patientId = res.patientId;
        });
    },
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then(res => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      this.$http
        .post(this.$api.USER_QRCODE_VARIFY_CODE, {
          phone: this.telphone
        })
        .then(() => {
          this.startCountDown();
        });
      // if (!this.verifyCode) {
      //   this.$toast("请输入图形验证码");
      //   return;
      // }
    },
    onSubmit() {
      this.$http
        .post(this.$api.USER_QRCODE_ARCHIVE_MODIFY, {
          functionType: "1",
          name: this.name,
          phone: this.telphone,
          idCard: this.idCard,
          patientId: this.patientId
        })
        .then(() => {
          this.$toast("修改成功成功");
          this.$router.go(-1);
        });
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.archive-modify-view {
  background: #efeff4;
  .van-field__label {
    color: black;
  }
  .van-field__control {
    font-size: 0.94rem;
  }
  .van-field__control:disabled {
    color: #555;
  }
  .label-title {
    font-weight: 600;
    font-size: 0.94rem;
  }

  .tip-info {
    padding: 1rem;
    color: white;
    line-height: 1.2rem;
    background: #1f90eb;

    p {
      display: flex;
      font-size: 0.81rem;
      opacity: 0.8;
      margin-block-start: 0.5em;
      margin-block-end: 0.5em;

      span {
        display: block;
        flex-shrink: 0;
        width: 0.5rem;
        height: 0.5rem;
        margin-top: 0.2rem;
        margin-right: 0.5rem;
        line-height: 1.2rem;
        background-color: white;
        border-radius: 50%;
      }
    }
  }
}
</style>
